import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=6ba3d2a7&"
import script from "./IconCheck.vue?vue&type=script&lang=ts&"
export * from "./IconCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports